import styled from "styled-components";

const StyledLogin = styled.div`
    display: flex;
    justify-content: center;
} 
`

export default StyledLogin;